var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 522,
    viewBox: "0 0 512 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 78.1512V373.849L136 452V295.675L135.864 295.608V156.37L136 156.302V8.06346e-06L0 78.1512Z",
    fill: "#37C896"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 373.849V78.1512L376 8.06346e-06V156.302L376.136 156.37V295.608L376 295.675V452L512 373.849Z",
    fill: "#37C896"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M376.612 296L256 365.651L135.388 296L0 374.175L256 522L512 374.175L376.612 296Z",
    fill: "#6473FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136 2.86353e-06L0 78.5L136 157",
    fill: "#8C50E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M376 157.057V-8.04804e-06L256 69.9435L136 -8.04804e-06V157.057L256 227L376 157.057Z",
    fill: "#6473FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.32fffb5b02dac0d561174361dbdd881d.svg";
export { ForwardRef as ReactComponent };